import { BackgroundColors } from '@/@types/types';

export default {
  path: 'collaboration-tools',
  name: 'settings.tools',
  meta: {
    requiresAuth: true,
    permissions: ['setting.alert.read'],
    breadCrumb: 'app.navigation-drawer.tools',
    background: BackgroundColors.SECONDARY,
  },
  component: () => import('@/views/FrontendNextRouteView.vue'),
};
